









import Vue from 'vue'
import User from '@/types/User.interface'
import VerificationForm from '@/components/VerificationForm.vue'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
export default Vue.extend({
    components: { VerificationForm },
    mixins: [tenantNavMixin],
    data() {
        return {
            //  Flag that determines we are creating a stripe customer
            creating: false,
            // Flag that determines if we've already resent an email verification code
            sentEmailOnce: false,
            // Flag that determines if a user is being verified
            processing: false,
            // The error message that appears on the the verification input
            errorMessage: null
        }
    },
    async mounted() {
        //  Send the email code automatically for user to pass two factor with
        this.$store.dispatch('authVerifyEmailSend')
    },
    computed: {
        params(): string {
            return this.$route.query ? `?${window.toUrlParams(this.$route.query)}` : ''
        },
        query(): string | null {
            //  If query params exist, return string format
            if (this.$route.query) return '?' + window.toUrlParams(this.$route.query)
            //  Else, return nothing
            return null
        },
        user(): User {
            return this.$store.getters.user
        },
    },
    methods: {
        confirmResend(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: `Email a new code?`,
                text: `Do you want to send a new verification code to <b>${this.user.email}</b>?`,
                icon: 'mdi-alert',
                color: 'yellow darken-2',
                callback: (result: boolean) => this.resend(result)
            })
        },
        onResendEmailVerification(): void {
            return this.sentEmailOnce ? this.confirmResend() : this.resend(true)
        },
        async onSubmit(code: number): Promise<void> {
            // Indicate that we are proccessing verification
            this.processing = true
            // Reset the error message
            this.errorMessage = null
            //  Create our payload
            const payload = {
                code: code,
            }
            //  Submit email code
            const response = await this.$store.dispatch('authVerifyEmail', payload)
            //  If response failed, set error
            if (!response) {
                this.errorMessage = 'Oops! That’s the wrong code. Please try again'
                this.processing = false
                return
            }
            //  If the user has one membership, direct them to the tenant dashboard
            //  Use deep linking param (goto) if available
            if (this.user.memberships.length == 1) this.goToTenant(this.user.memberships[0].tenant_id, this.$route.query.goto || null)
            //  If the user has more than one membership, direct them to tenant selection
            if (this.user.memberships.length > 1) this.$router.push(`/memberships${this.params}`)
            // Else the user is still in the registration flow and we need to have them continue where they left off
            else this.routeLogin(this.user)
        },
        async resend(dialog_result: boolean): Promise<void> {
            //  If the request is not confirmed, do nothing
            if (!dialog_result) return
            //  Send a verification code to the authenticated user's phone
            const sent = await this.$store.dispatch('authVerifyEmailSend')
            //  If the verification code was NOT sent, do nothing
            if (!sent) return
            //  Else, notify the user of successfully sent verification code to their device
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Verification Code Sent',
                text: `A new verification code has been sent to ${this.user.email}.`,
                icon: 'mdi-check-circle',
                color: 'primary'
            })
            //  Remember the user has resent a code at least once, this tiggers a confirm on the second send
            this.sentEmailOnce = true
        },
    }
})
